export const REF_CLICK_DEBUG_FLOW = "ref-click-debug";
export const SEQ_LOG_COMPONENT_NAME = "Creference";
export const KEYBOARD_ENTER = "Enter";
export const KEYBOARD_SPACE = " ";
